<template>     
    <div class="machine" v-on:click="openUrl(machine.url)">
        <a :href="machine.url" class="img">
            <span class="machine-top">
                <img :src="machine.thumbnail" alt="" />
                <span v-if="machine.isHot" class="flag flag-special">{{ texts.specialOffer }}</span>
                <span class="info">
                    <span class="h3">{{ machine.name }}</span>
                    <span class="h4">{{ machine.machineType }}</span>
                </span>
            </span>
            <span class="bar">
                <span class="bar-item"><i>{{ texts.referenceNumberShort }}</i> {{ machine.referenceNumber }}</span>
                <span class="bar-item"><i>{{ texts.productionYear }}</i> {{ machine.productionYear }}</span>
                <span v-on:click.stop.prevent="toggleFavourites(machine)" v-bind:class="{ 'active' : machine.isFavourite, 'add-to-favourites': true }"></span>
            </span>
        </a>
    </div>
</template>

<script>
    var axios = require('axios')
    export default {
        name: 'machine',
        props: {
            machine: {
                type: Object,
                required: true
            },
            texts: {
                type: Object,
                required: true
            }
        },
        methods: {
            openUrl(url) {
                window.location.href = url;
            },
            toggleFavourites(machine) {
                var url = machine.isFavourite ? '/api/remove-from-popular-machines' : '/api/add-to-popular-machines';
                axios.post(url, {
                    id: machine.id
                }).then(response => {
                    machine.isFavourite = !machine.isFavourite;
                    $('#favorite-counter').html(response.data.count);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// _machine.vue?749a9feb